export const INPUT_NAME_RESERVED_GROUP1 = 'group1';

export const INPUT_NAME_RESERVED_GROUP2 = 'group2';

export const INPUT_NAME_RESERVED_GROUP_ARR = [
  INPUT_NAME_RESERVED_GROUP1,
  INPUT_NAME_RESERVED_GROUP2,
] as const;
